import "./RegisterForWarrant.css";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";

import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ReactLoading from "react-loading";
import {
  setIDMatchVisible,
  setLoginVisible,
} from "../../store/modals/modalActions";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const RegisterForWarrant = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const infringement = useAppSelector((state) => state.fine.infringement);
  const user = useAppSelector((state) => state.auth.user);
  const authLoading = useAppSelector((state) => state.auth.loading);
  const searchedID = useAppSelector((state) => state.fine.searchedID);
  const idFines = useAppSelector((state) => state.fine.idFines);

  useEffect(() => {
    if (user && infringement) {
      navigate("/fine");
    }
    // if (user && infringement && !searchedID) {
    //   navigate("/fine");
    // }
    // if (user && infringement && searchedID) {
    //   if (
    //     infringement.idNumber.trim() === user.id_number.trim() ||
    //     !infringement.warrantOfArrestPending
    //   ) {
    //     navigate("/fine");
    //   } else {
    //     dispatch(setIDMatchVisible(true));
    //   }
    // }
  }, [infringement, user]);

  useEffect(() => {
    if (!infringement) navigate("/");
  }, []);

  const onLoginClicked = () => {
    dispatch(setLoginVisible(true));
  };
  const onRegisterClicked = () => {
    navigate("/register");
  };
  return (
    <div className="register-for-warrant-container">
      {authLoading && (
        <>
          <div className="register-overlay" style={{ zIndex: 2 }} />
          <div
            style={{
              position: "absolute",
              marginTop: "50vh",
              zIndex: 3,
            }}
          >
            <ReactLoading type="bubbles" color="#e97700" />
          </div>
        </>
      )}
      <Header hideLoginButton />
      <div className="register-for-warrant-content">
        <p className="register-for-warrant-heading">This fine has a warrant</p>
        <p className="register-for-warrant-subheading">
          Please login or register to pay
        </p>
        {/* {searchedID && idFines && idFines.length > 0 ? (
          <div className="please-note-id">
            <p>
              <b>PLEASE NOTE:</b> The ID number used to register an account
              needs to match the ID number used to identify the fine:{" "}
              {infringement?.idNumber}
            </p>
          </div>
        ) : null} */}
        <div className="register-for-warrant-button-container">
          <div
            className="register-for-warrant-button"
            style={{ backgroundColor: "#e97700", color: "white" }}
            onClick={() => onLoginClicked()}
          >
            <p>I have an account</p>
            <p>LOGIN</p>
          </div>
          <div
            className="register-for-warrant-button"
            style={{ borderColor: "#18283c" }}
            onClick={() => onRegisterClicked()}
          >
            <p>I don't have an account</p>
            <p>REGISTER</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RegisterForWarrant;
